module.exports = __webpack_public_path__ + "img/login-pic-m.bc8c1b8f.jpg";